import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const assetSchema = z.object({
  /** アセット名 */
  asset: z.string(),
  /** 利用可能な量 */
  free_amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** 精度 */
  amount_precision: z.number().int(),
  /** 保有量 */
  onhand_amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** ロックされている量 */
  locked_amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** ロックされている量のうち出金中数量 */
  withdrawing_amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
})
